import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-daka",
  "use": "icon-daka-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-daka\"><defs><style></style></defs><path d=\"M801.513 328.471h-101.47l-31.65-63.348c-15.826-22.202-41.24-34.91-66.56-31.698h-133.12a90.764 90.764 0 0 0-69.725 31.651l-31.651 63.395h-98.304c-47.523 3.212-82.386 38.028-82.386 85.597v332.754c0 44.358 34.863 82.385 82.386 82.385H801.42c44.357 0 82.385-38.027 82.385-82.385v-332.8c0-47.477-38.028-85.55-82.385-85.55zM307.06 467.921c-19.037 0-34.909-12.66-34.909-31.65 0-19.084 12.707-34.91 31.744-34.91 18.99 0 34.863 12.707 34.863 31.698v3.165c0 19.037-15.826 31.697-31.698 31.697zm228.166 278.9c-91.88 0-167.982-76.054-167.982-167.982 0-91.88 76.101-164.77 167.982-164.77S703.21 490.123 703.21 582.003c0 91.928-76.102 164.771-167.983 164.771z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/daka.svg
// module id = XCHT
// module chunks = 53